var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { lighten } from '@theme-ui/color';
import { createOverridableComponent } from '../util/OverridableComponent';
import { useThemeStyle } from '../hooks/useThemeStyle';
import { desaturate } from 'polished';
import { useRouter } from '../hooks/useRouter';
export var Clickable = createOverridableComponent('div', function (_a, Wrapper, ref) {
    var onKeyPress = _a.onKeyPress, to = _a.to, onClick = _a.onClick, props = __rest(_a, ["onKeyPress", "to", "onClick"]);
    var _b = useRouter() || {}, history = _b.history, location = _b.location;
    if (to && !history) {
        throw new Error("Clickable used with to={".concat(to, "} outside router context"));
    }
    var css = useThemeStyle('clickable', onClick || to
        ? {
            cursor: 'pointer',
            '&:hover': {
                bg: function (t) { return desaturate(0.25, lighten('secondary', 0.65)(t)); },
            },
        }
        : undefined);
    return (jsx(Wrapper, __assign({}, props, { ref: ref, css: css, tabIndex: onClick || to ? 0 : undefined, role: "button", onClick: to
            ? function (e) {
                if (onClick) {
                    onClick(e);
                }
                if (!e.defaultPrevented) {
                    var result = typeof to === 'function' ? to(location) : to;
                    if (typeof result === 'string') {
                        history.push(result);
                    }
                    else {
                        history.push(result.pathname || '', result.state);
                    }
                }
            }
            : onClick, onKeyPress: onClick || to
            ? function (e) {
                if (onKeyPress) {
                    onKeyPress(e);
                }
                if (!e.defaultPrevented &&
                    e.target &&
                    (e.key === ' ' || e.key === 'Enter')) {
                    e.preventDefault();
                    e.target.click();
                }
            }
            : onKeyPress })));
});
//# sourceMappingURL=Clickable.js.map